import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { StockLimitReportDataType } from "../../../redux/reports/reportsType";
import StockLimitQuantityChart from "./StockLimitQuantityChart";

type AppProps = {
  data: StockLimitReportDataType[] | [];
  tableHeader: TableHeadersType[];
};
const StockLimitsTableData = ({ data, tableHeader }: AppProps) => {
  return (
    <>
      {data &&
        data?.length > 0 &&
        data?.map((itemData: any) => {
          return (
            <tr key={itemData?._id}>
              {tableHeader?.map((item: TableHeadersType) => {
                if (item?.value === "sku_number") {
                  return <td>{itemData?.sku_number}</td>;
                } else if (item?.value == "stock_item_name") {
                  return <td>{itemData?.stock_item_name}</td>;
                } else if (item?.value == "stock_group_name") {
                  return <td>{itemData?.stock_group_name}</td>;
                } else if (item?.value == "stock_unit_name") {
                  return <td>{itemData?.stock_unit_name}</td>;
                } else if (item?.value == "min_quantity") {
                  return (
                    <td>
                      {itemData?.min_quantity ? itemData?.min_quantity : "0"}
                    </td>
                  );
                } else if (item?.value == "closing_qty") {
                  const isBelowMin =
                   ( itemData?.min_quantity !== null || itemData?.min_quantity == null) &&
                   ( itemData?.min_quantity !== undefined ||  itemData?.min_quantity == undefined) &&
                    itemData?.closing_qty < itemData?.min_quantity;
                  const isAboveMax =
                  ( itemData?.max_quantity !== null || itemData?.max_quantity == null) &&
                  ( itemData?.max_quantity !== undefined ||  itemData?.max_quantity == undefined) &&
                    itemData?.closing_qty > itemData?.max_quantity;
                  return (
                    <td
                      style={{
                        color: isBelowMin || isAboveMax ? "#dd4433" : "inherit",
                      }}
                    >
                      {itemData?.closing_qty}
                    </td>
                  );
                } else if (item?.value == "max_quantity") {
                  return (
                    <td>
                      {itemData?.max_quantity ? itemData?.max_quantity : "0"}
                    </td>
                  );
                } else if (item?.value == "graph") {
                  return (
                    <td>
                      <>
                        <StockLimitQuantityChart
                          minQuantity={itemData?.min_quantity}
                          maxQuantity={itemData?.max_quantity}
                          currentQuantity={itemData?.closing_qty}
                          graphPercentage={itemData?.graph_percentage}
                        />
                      </>
                    </td>
                  );
                } else {
                  <td>{itemData[item?.value]}</td>;
                }
              })}
            </tr>
          );
        })}
    </>
  );
};

export default StockLimitsTableData;
